import * as Styled from './WhyTrovaItemStyles';

interface WhyTrovaItemStandardProps {
  path: Path;
  header: string;
  text: string;
}

interface Path{
  default: string;
}

const WhyTrovaItem = ({path, header, text}:WhyTrovaItemStandardProps) => {
  return (
    <div>
      <Styled.StyledImg src={path.default} alt="Described icon"/>
      <Styled.H3Styled>{header}</Styled.H3Styled>
      <Styled.StyledParagraph>{text}</Styled.StyledParagraph>
    </div>
  );
}

export default WhyTrovaItem;